export const obfuscateEmail = (email: string): string => {
  const [start, end] = (email || '').split('@')

  return `${start.substr(0, 3)}****@${end}`
}
